import React from 'react';
import { motion } from 'framer-motion';
import { Linkedin, Activity, ChevronRight } from 'lucide-react';

const TeamCard = ({
    name,
    role,
    id,
    image,
    backProtocol,
    backFocus,
    isAdvisor = false,
    linkedInLink,
    imagePosition = 'object-cover'
}) => {
    return (
        <div className="group relative w-full max-w-[180px] h-[240px] mx-auto perspective-1000">
            {/* Main Card Container */}
            <div className="relative w-full h-full overflow-hidden rounded-2xl bg-[#0a0a0a] border border-white/10 transition-all duration-500 group-hover:shadow-[0_0_30px_rgba(16,185,129,0.2)] group-hover:border-emerald/50">

                {/* 1. Background Image Layer */}
                <div className="absolute inset-0 z-0">
                    <img
                        src={image}
                        alt={name}
                        className={`w-full h-full ${imagePosition} transition-all duration-700 ease-out filter grayscale group-hover:grayscale-0 group-hover:scale-110`}
                    />
                    {/* Gradient Overlay for text readability */}
                    <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/80 to-transparent" />
                </div>

                {/* 2. Cyber UI Overlays - Removed ID Tag */}

                {/* 3. Idle Content (Always Visible) */}
                <div className="absolute bottom-3 left-4 z-20">
                    <h3 className="text-[10px] font-bold text-white uppercase tracking-tight mb-1 font-sans">{name}</h3>
                    <p className={`text-[7.5px] font-bold uppercase tracking-widest ${isAdvisor ? 'text-gold-border' : 'text-neon-lime'}`}>{role}</p>
                </div>

                {/* LinkedIn Icon - Center on Hover */}
                {linkedInLink && linkedInLink !== '#' && (
                    <a
                        href={linkedInLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="absolute inset-0 z-30 flex items-center justify-center bg-black/60 backdrop-blur-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300"
                        onClick={(e) => e.stopPropagation()}
                        aria-label="LinkedIn Profile"
                    >
                        <div className="w-16 h-16 rounded-full bg-[#0077b5] hover:bg-[#006097] flex items-center justify-center transition-all duration-300 transform hover:scale-110 shadow-lg">
                            <Linkedin size={32} strokeWidth={0} fill="white" />
                        </div>
                    </a>
                )}
            </div>
        </div>
    );
};

export default TeamCard;
